import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'

// http 请求拦截器
import httpRequest from './utils/httpRequest.js'
Vue.prototype.$http = httpRequest;

// vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import customConfirm from './components/customConfirm/index.js'
Vue.prototype.$confirm = customConfirm

router.beforeEach((to, from, next)=>{
  var _value = to.query.token;
  if(_value != null && _value != undefined && _value != 'undefined'){
    localStorage.setItem("TOKEN",_value);
  }
  next();
})

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
